import { Routes } from '@angular/router';

export const routes: Routes = [
   {
    path: 'signin',
    loadComponent: () => import('./pages/userManagement/login').then(x => x.Login),
  },
  {
    path: 'signout',
    loadComponent: () => import('./pages/userManagement/login').then(x => x.Login),
  },
  {
    path: 'recover',
    loadComponent: () => import('./pages/userManagement/recover').then(x => x.Recover),
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home').then(x => x.Home),
  },
  {
    path: 'families',
    loadComponent: () => import('./pages/families/families').then(x => x.Families),
  },
  {
    path: 'family-detail/:familyId',
    loadComponent: () => import('./pages/family-detail/family-detail').then(x => x.FamilyDetail),
  },
  {
      path: 'appointment-stepper',
    loadComponent: () => import('./pages/appointment-stepper/appointment-stepper').then(x => x.AppointmentStepper),
  },
  {
    path: 'appointment-stepper/:familyId',
    loadComponent: () => import('./pages/appointment-stepper/appointment-stepper').then(x => x.AppointmentStepper),
  },
  {
    path: 'buildings',
    loadComponent: () => import('./pages/buildings/buildings').then(x => x.Buildings),
  },
  {
    path: 'teams',
    loadComponent: () => import('./pages/teams/teams').then(x => x.Teams),
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard').then(x => x.Dashboard),
  }
];
